module.exports = __webpack_public_path__ + "img/bg.44bb415d.jpg";